// Module
var code = "<div class=\"mc-sm-loader loading-content-container\"> <a ng-click=\"vm.close()\" class=\"mc-sm-close first-close\"> <close></close> </a> <div class=\"mc-sm-message-holder\"> <preloader-dot></preloader-dot> <p class=\"mc-sm-message\">{{vm.loadingMessage}}</p> </div> </div> ";
// Exports
module.exports = code;